import React from 'react';
import { Bone, Card, Row, Col, Container } from './SkeletonPulse';

const StatsSkeleton = () => (
  <Container style={{ paddingTop: 12, paddingBottom: 40 }}>
    {/* Range selector pills */}
    <Row gap={0} style={{ justifyContent: 'center', marginBottom: 16 }}>
      <Bone width="100%" height={40} radius={999} />
    </Row>

    {/* Donut chart card */}
    <Card style={{ marginBottom: 12 }}>
      <Col gap={16} style={{ alignItems: 'center' }}>
        {/* Donut placeholder */}
        <Bone circle height={160} />
        {/* Legend rows */}
        <Col gap={10} style={{ width: '100%' }}>
          {[1, 2, 3, 4].map(i => (
            <Row key={i} gap={10}>
              <Bone circle height={12} />
              <Bone width="40%" height={12} />
              <div style={{ flex: 1 }} />
              <Bone width={30} height={12} />
            </Row>
          ))}
        </Col>
      </Col>
    </Card>

    {/* Streak + week card */}
    <Card style={{ marginBottom: 12 }}>
      <Col gap={14}>
        <Row gap={10}>
          <Bone circle height={44} />
          <Col gap={6}>
            <Bone width={80} height={20} />
            <Bone width={120} height={12} />
          </Col>
        </Row>
        {/* 7 day dots */}
        <Row gap={8} style={{ justifyContent: 'space-between' }}>
          {[1, 2, 3, 4, 5, 6, 7].map(i => (
            <Bone key={i} circle height={28} />
          ))}
        </Row>
        <Bone width="70%" height={12} style={{ alignSelf: 'center', margin: '0 auto' }} />
      </Col>
    </Card>

    {/* Quick stats — 2 columns */}
    <Row gap={8} style={{ marginBottom: 12 }}>
      <Card style={{ flex: 1, padding: '16px 14px', borderRadius: 16 }}>
        <Col gap={8} style={{ alignItems: 'center' }}>
          <Bone circle height={32} />
          <Bone width={40} height={22} />
          <Bone width={70} height={11} />
        </Col>
      </Card>
      <Card style={{ flex: 1, padding: '16px 14px', borderRadius: 16 }}>
        <Col gap={8} style={{ alignItems: 'center' }}>
          <Bone circle height={32} />
          <Bone width={40} height={22} />
          <Bone width={70} height={11} />
        </Col>
      </Card>
    </Row>

    {/* Area progress card */}
    <Card>
      <Col gap={12}>
        <Bone width={150} height={15} />
        {[1, 2, 3].map(i => (
          <Col key={i} gap={6}>
            <Row gap={8}>
              <Bone width="35%" height={12} />
              <div style={{ flex: 1 }} />
              <Bone width={24} height={12} />
            </Row>
            <Bone width="100%" height={6} radius={3} />
          </Col>
        ))}
      </Col>
    </Card>
  </Container>
);

export default StatsSkeleton;
